module.exports = __webpack_public_path__ + "img/pg4-article4-bg.ba6ffbb8.png";